// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advanced[data-v-fbe66248]>.vue-portal-target:empty,.advanced[data-v-fbe66248]>.vue-portal-target:empty+.spacer{display:none}", ""]);
// Exports
module.exports = exports;
